import { ROLES } from '../actionTypes';

export const fetchRoles = () => ({
  type: ROLES.FETCH,
});

export const fetchInternalRoles = () => ({
  type: ROLES.INTERNAL_FETCH,
});
